import { toast } from "react-toastify";

export async function getErrorToast(error: any) {
  let message = "";
  await error.json().then(async (body: any) => {
    if (body.messages) {
      message = body.messages[0];
    }
  });
  console.log(message);
  if (message !== "") {
    toast.error(message);
  } else {
    let msg = (error as Error).message;
    let name = (error as Error).name;
    toast.error(name + ": " + msg);
  }
}

export function getSuccessToast(message: any) {
  toast.success(message);
}
